<script>
  import Button from "../atoms/Button.svelte";
  import Icon from "../atoms/Icon.svelte";

  export let src = ""; // The source URL of the video
  export let poster = ""; // The poster image URL to display before the video plays or when it is paused
  export let videoTitle = "decorative muted video"; // The title of the video for accessibility purposes
  /**
   * The class for the container element.
   * @type {string}
   */
  export let containerClass = "";

  let videoRef;

  let isPlaying = true;

  function togglePlayPause() {
    if (!videoRef) {
      return;
    }

    if (videoRef.paused) {
      videoRef.play();
      isPlaying = true;
    } else {
      videoRef.pause();
      isPlaying = false;
    }
  }
</script>

<div class="override-video {containerClass}" id="video-container">
  <video
    bind:this={videoRef}
    {src}
    {poster}
    autoplay
    loop
    muted
    playsinline
    id="contentful-video"
    aria-label={`Decorative background video titled ${videoTitle}, this video is always muted and plays in a loop`}
  >
    Your browser does not support the video tag.
  </video>
  <Button
    buttonClass="override-[video]:absolute override-[video]:px-5 override-[video]:md:px-6 bottom-5 right-5"
    on:click={togglePlayPause}
    variant="outline"
    theme="black"
    ariaLabel={isPlaying ? "Pause" : "Play"}
  >
    <Icon slot="icon" iconClass="text-inherit" name={isPlaying ? "pause" : "play"} />
  </Button>
</div>
